import Vue from 'vue';
import Vuex from 'vuex';
import * as firebase from 'firebase';
import 'firebase/firestore';
import storeCategories from './server/init';

Vue.use(Vuex);

let cart = window.localStorage.getItem('cart');

export default new Vuex.Store({
  state: {
    storeCategories: [],
    storeSubCategories:[],
    storeFilters: [],
    storeProducts: [],
    activeStoreProduct: {},
    activeCategory: '',
    storeCategoryBannerContent: [],
    activeCategoryMobileImage: '',
    activeCategoryTabletImage: '',
    activeCategoryDesktopImage: '',
    activeCategoryBannerAlt: '',
    activeCategoryBannerDescription: '',
    activeCategoryBannerTitle: '',
    activeSubCategory: 'All Items',
    activeFilter: 'Filter By',
    showSubCategoryDropdown: false,
    showFiltersDropdown: false,
    activeSubCategorySelected: false,
    activeFilterSelected: false,
    cartItems: cart ? JSON.parse(cart) : [],
    freeShipping: 75.00
  },
  mutations: {
    SET_STORE_CATEGORIES(state, storeCategories) {
      state.storeCategories.push(storeCategories);
    },

    SET_STORE_SUB_CATEGORIES(state, subcategories) {
      state.storeSubCategories.push(subcategories);
    },

    SET_STORE_SUB_CATEGORY_BANNER_CONTENT(state, subcategoriesContent) {
      state.storeCategoryBannerContent.push(subcategoriesContent);
    },

    SET_STORE_FILTERS(state, filters) {
      state.storeFilters.push(filters);
    },

    SHOW_STORE_SUB_CATEGORIES_DROPDOWN(state) {
      state.showSubCategoryDropdown = true;
    },

    SHOW_STORE_FILTERS_DROPDOWN(state) {
      state.showFiltersDropdown = true;
    },

    HIDE_STORE_SUB_CATEGORIES_DROPDOWN(state) {
      state.showSubCategoryDropdown = false;
    },

    HIDE_STORE_FILTERS_DROPDOWN(state) {
      state.showFiltersDropdown = false;
    },

    SET_STORE_PRODUCTS(state, products) {
      state.storeProducts.push(products);
    },

    SET_ACTIVE_CATEGORY(state, category) {
      state.activeCategory = category;
    },

    SET_ACTIVE_CATEGORY_MOBILE_IMAGE(state, categoryMobileImage) {
      state.activeCategoryMobileImage = categoryMobileImage;
    },

    SET_ACTIVE_CATEGORY_TABLET_IMAGE(state, categoryTabletImage) {
      state.activeCategoryTabletImage = categoryTabletImage;
    },

    SET_ACTIVE_CATEGORY_DESKTOP_IMAGE(state, categoryDesktopImage) {
      state.activeCategoryDesktopImage = categoryDesktopImage;
    },

    SET_ACTIVE_CATEGORY_TITLE(state, categoryBannerTitle) {
      state.activeCategoryBannerTitle = categoryBannerTitle;
    },

    SET_ACTIVE_CATEGORY_DESCRIPTION(state, categoryBannerDescription) {
      state.activeCategoryBannerDescription = categoryBannerDescription;
    },

    SET_ACTIVE_CATEGORY_BANNER_ALT(state, categoryAlt) {
      state.activeCategoryBannerAlt = categoryAlt;
    },

    SET_ACTIVE_SUBCATEGORY(state, subCategory) {
      state.activeSubCategory = subCategory;
      state.activeSubCategorySelected = true;
    },

    SET_ACTIVE_PRODUCT(state, product) {
      state.activeStoreProduct = product;
    },

    RESET_ACTIVE_PRODUCT(state) {
      state.activeStoreProduct = ''
    },

    RESET_ACTIVE_SUBCATEGORY(state) {
      state.activeSubCategory = 'All Items';
      state.activeSubCategorySelected = false;
    },

    RESET_ACTIVE_FILTER(state) {
      state.activeFilter = 'Filter By';
      state.activeFilterSelected = false;
    },

    SET_ACTIVE_FILTER(state, filter) {
      state.activeFilter = filter;
      state.activeFilterSelected = true;
    },

    REMOVE_STORE_SUB_CATEGORIES(state) {
      state.storeSubCategories = [];
    },

    REMOVE_STORE_FILTERS(state) {
      state.storeFilters = [];
    },

    REMOVE_STORE_PRODUCTS(state) {
      state.storeProducts = []
    },

    ADD_TO_CART(state, product) {
      state.cartItems.push(product);
    },

    REMOVE_FROM_CART(state, index) {
      state.cartItems.splice(index, 1);
    },

    SAVE_CART(state) {
      window.localStorage.setItem('cart', JSON.stringify(state.cartItems))
    },

    CLEAR_CART(state) {
      state.cartItems = [];
    }



  },

  actions: {
    async setStoreCategories({commit}, categories) {
      commit('REMOVE_STORE_PRODUCTS');
      commit('REMOVE_STORE_SUB_CATEGORIES');
      commit('HIDE_STORE_SUB_CATEGORIES_DROPDOWN');
      commit('REMOVE_STORE_FILTERS');
      commit('HIDE_STORE_FILTERS_DROPDOWN');
      storeCategories.collection('storeCategories').get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          const categories = doc.data();
          commit('SET_STORE_CATEGORIES', categories);
          if (categories.category === 'featured') {
            commit('SET_ACTIVE_CATEGORY', categories.category);
            if (categories.products) {
              const products = categories.products;
              for(let i = 0; i < products.length; i++) {
                commit('SET_STORE_PRODUCTS', products[i]);
              }
            }
          }
        });
      });
    },

    async setStoreSubCategories({commit}) {
      storeCategories.collection('storeCategories').get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          const categories = doc.data();
          if(categories.subCategories) {
            const subCategories = categories.subCategories;
            if(!this.state.storeSubCategories.length) {
              for( let i = 0; i < subCategories.length; i++) {
                commit('SET_STORE_SUB_CATEGORIES', subCategories[i].title);
              }
            }
          }
          if(categories.filters) {
            const filters = categories.filters;
            if(!this.state.storeFilters.length) {
              for(let x = 0; x < filters.length; x++) {
                commit('SET_STORE_FILTERS', filters[x].title);
              }
            }
          }
        })
      })
    },


    async updateStoreCategories({commit}, category) {
      commit('REMOVE_STORE_PRODUCTS');
      commit('RESET_ACTIVE_SUBCATEGORY');
      commit('RESET_ACTIVE_FILTER');
      storeCategories.collection('storeCategories').get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          const categories = doc.data();
          if (category.category === categories.category) {
            commit('SET_ACTIVE_CATEGORY', categories.category);
            commit('SET_ACTIVE_CATEGORY_MOBILE_IMAGE', categories.mobileBannerImage);
            commit('SET_ACTIVE_CATEGORY_TABLET_IMAGE', categories.tabletBannerImage);
            commit('SET_ACTIVE_CATEGORY_DESKTOP_IMAGE', categories.desktopBannerImage);
            commit('SET_ACTIVE_CATEGORY_TITLE', categories.bannerTitle);
            commit('SET_ACTIVE_CATEGORY_DESCRIPTION', categories.bannerDescription);
            commit('SET_ACTIVE_CATEGORY_BANNER_ALT', categories.bannerAlt);
            if(category.subCategory) {
              commit('SET_ACTIVE_SUBCATEGORY', category.subCategory);
              commit('SET_ACTIVE_CATEGORY_MOBILE_IMAGE', category.mobileBannerImage);
              commit('SET_ACTIVE_CATEGORY_TITLE', category.title);
              commit('SET_ACTIVE_CATEGORY_DESCRIPTION', category.bannerDescription);
              commit('SET_ACTIVE_CATEGORY_BANNER_ALT', category.altTag);
              if(category.filters) {
                commit('SHOW_STORE_FILTERS_DROPDOWN');
              }
            }
            if (categories.subCategories) {
              const subCategories = categories.subCategories;
              for( let i = 0; i < subCategories.length; i++) {
                commit('SET_STORE_SUB_CATEGORIES', subCategories[i].title);
                commit('SET_STORE_SUB_CATEGORY_BANNER_CONTENT',
                  {
                    mobileImage: subCategories[i].mobileBannerImage,
                    tabletImage: subCategories[i].tabletBannerImage,
                    desktopImage: subCategories[i].desktopBannerImage,
                    category: subCategories[i].category,
                    bannerTitle: subCategories[i].bannerTitle,
                    bannerDescription: subCategories[i].bannerDescription,
                    bannerAltTag: subCategories[i].bannerAltTag
                  }
                );
                commit('SHOW_STORE_SUB_CATEGORIES_DROPDOWN');
              }
              if(categories.filters) {
                const filters = categories.filters;
                for( let i = 0; i < filters.length; i++)
                commit('SET_STORE_FILTERS', filters[i].title);
              }
            } else {
              commit('REMOVE_STORE_SUB_CATEGORIES');
              commit('HIDE_STORE_SUB_CATEGORIES_DROPDOWN');
              commit('REMOVE_STORE_FILTERS');
              commit('HIDE_STORE_FILTERS_DROPDOWN');
            }
            if (categories.products) {
              const products = categories.products;
              for(let i = 0; i < products.length; i++) {
                commit('SET_STORE_PRODUCTS', products[i]);
              }
            }
          }
        })
      })
    },

    async setFilterMenus({commit, state}, category) {
      commit('SET_STORE_CATEGORIES')
      commit('SET_ACTIVE_CATEGORY', category);
    },

    async updateStoreSubCategory({commit, state}, subCategory) {
      commit('RESET_ACTIVE_SUBCATEGORY');
      commit('RESET_ACTIVE_FILTER');
      commit('SET_ACTIVE_SUBCATEGORY', subCategory);
      if(state.activeSubCategorySelected && state.storeFilters) {
        commit('SHOW_STORE_FILTERS_DROPDOWN');
      }
      const bannerContent = state.storeCategoryBannerContent;
      for(let i = 0; i < bannerContent.length; i++) {
        if( state.activeSubCategory.toLowerCase() == bannerContent[i].category){
          commit('SET_ACTIVE_CATEGORY_MOBILE_IMAGE', bannerContent[i].mobileImage);
          commit('SET_ACTIVE_CATEGORY_TABLET_IMAGE', bannerContent[i].tabletImage);
          commit('SET_ACTIVE_CATEGORY_DESKTOP_IMAGE', bannerContent[i].desktopImage);
          commit('SET_ACTIVE_CATEGORY_TITLE', bannerContent[i].bannerTitle);
          commit('SET_ACTIVE_CATEGORY_DESCRIPTION', bannerContent[i].bannerDescription);
          commit('SET_ACTIVE_CATEGORY_BANNER_ALT', bannerContent[i].bannerAlt);
        }
      }
    },

    async updateStoreFilter({commit, state}, filter) {
      commit('SET_ACTIVE_FILTER', filter);
    },

    async setActiveStoreProduct({commit, state}, product) {
      commit('REMOVE_STORE_SUB_CATEGORIES');
      commit('REMOVE_STORE_FILTERS');
      commit('SET_ACTIVE_PRODUCT', product);
    },

    async clearMenus({commit, state}) {

    },

    async addItemToCart({commit, state}, item) {
      let found = state.cartItems.find(product => product.id == item.id);
      if(found) {
        found.quantity++
        commit('SAVE_CART');


      } else {
        commit('ADD_TO_CART', item);
        commit('SAVE_CART');
      }

    },

    async updateItemQuantity({commit, state}, [item, value]) {
      let found = state.cartItems.find(product => product.id == item.id);
      if(found) {
        found.quantity = value;
        commit('SAVE_CART');
      }
    },

    async removeItemFromCart({commit, state}, item) {
      let index = state.cartItems.indexOf(item);
      if(index != -1) {
        commit('REMOVE_FROM_CART', index);
        commit('SAVE_CART');
      }
    },

    async clearShoppingCart({commit}) {
      commit('CLEAR_CART');
      commit('SAVE_CART');
    }




  },

  getters: {
    getActiveProducts(state) {
      if(state.storeProducts) {
        if(state.activeFilterSelected){
          return state.storeProducts.filter(filter => filter.filter == state.activeFilter && filter.subCategory == state.activeSubCategory.toLowerCase());
        } else if (state.activeSubCategorySelected) {
          return state.storeProducts.filter(subCategory => subCategory.subCategory == state.activeSubCategory.toLowerCase())
        } else {
          return state.storeProducts;
        }
      }
    },

    getActiveStoreProduct(state) {
      return state.activeStoreProduct;
    },

    getItemsCount: state => state.cartItems.reduce((total, cartItem) => total + cartItem.quantity, 0),

    getItemsTotal: state => state.cartItems.reduce((cartItem) => cartItem.price * cartItem.quantity, 0),

    getTotalPrice: state => state.cartItems.reduce((total, cartItem) => total + cartItem.quantity * cartItem.price, 0),

  }
});
